<template>
  <div>
    <h1 class="page-header">Stock Alert</h1>
    <ts-card>
      <ts-card-wrapper> </ts-card-wrapper>
      <table class="table ui-table">
        <thead>
          <tr>
            <th>branch code</th>
            <th>branch name kh</th>
            <th>branch name en</th>
            <th style="text-align: center; width: 1px;">alert</th>
          </tr>
          <tr v-if="loading">
            <th colspan="4" class="table-data-loading">
              <div class="table-data-loading__slider">
                <div class="table-data-loading__line"></div>
                <div class="table-data-loading__subline table-data-loading__subline__inc"></div>
                <div class="table-data-loading__subline table-data-loading__subline__dec"></div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ resources.branch_code }}</td>
            <td>{{ resources.branch_name_kh }}</td>
            <td>{{ resources.branch_name_en }}</td>
            <td>
              <div class="switcher" v-if="resources.stock_alert_setting">
                <input
                  type="checkbox"
                  name="switcher_checkbox_1"
                  id="switcher_checkbox_1"
                  v-model="model.is_alert"
                  @change="store"
                />
                <label for="switcher_checkbox_1"></label>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </ts-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'stockAlertSetting',
  data() {
    return {
      model: {
        is_alert: ''
      },
      loading: false,
      columns: [
        { name: 'branch code' },
        { name: 'branch name kh' },
        { name: 'branch name en' },
        { name: 'alert', style: 'text-align:center; width: 1px;' }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('inventory/stockAlertSetting', ['resources'])
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('inventory/stockAlertSetting/fetch', attributes)
        .then(response => {
          this.loading = false
          this.model.is_alert = response.data.stock_alert_setting.is_alert
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    store() {
      this.$store
        .dispatch('inventory/stockAlertSetting/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.disable = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.disable = false
        })
    }
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('inventory/stockAlertSetting/RECEIVE_RESOURCES', {})
    }
    next()
  }
}
</script>

<style lang="css" scoped>
	.switcher label:before {
    width: 37px !important;
    height: 18px !important;
	}

	.switcher label:after {
    height: 17px !important;
    width: 17px !important;
    left: 2px;
    top: 0px !important;
}
</style>
